// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { browserLocalPersistence, getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyCQ1UJN2UUd9AzwVhClUi78FA8w4I9poYY",
  authDomain: "flyinglab-21ae1.firebaseapp.com",
  projectId: "flyinglab-21ae1",
  storageBucket: "flyinglab-21ae1.appspot.com",
  messagingSenderId: "188330401028",
  appId: "1:188330401028:web:191b042fc73738ce274451",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const firebaseAuth = getAuth(firebaseApp);

export default firebaseApp;
